import { UTM_MARKS } from 'constants/utmMarks';

import { isMarkValueNotSet } from './isMarkValueNotSet';

export const getUtmMarksFromQueryOrCookie = (query: Record<string, string>, cookie: Record<string, string>) => {
  const result = {} as Record<ValuesOf<typeof UTM_MARKS>, string>;
  return Object.values(UTM_MARKS).reduce((prev, name) => {
    const markName = name as ValuesOf<typeof UTM_MARKS>;

    const queryValue = query[markName];
    if (queryValue && !isMarkValueNotSet(markName, queryValue)) {
      prev[markName] = queryValue;
      return prev;
    }

    const cookieValue = cookie[markName];
    if (cookieValue && !isMarkValueNotSet(markName, cookieValue)) {
      prev[markName] = cookieValue;
      return prev;
    }

    prev[markName] = markName === UTM_MARKS.medium ? '(none)' : '(not set)';
    return prev;
  }, result);
};
